import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user_details: ""
  };
  
  const UserDetailStateSlice = createSlice({
    name: 'user_details',
    initialState: initialState,
    reducers: {
      storeUserDetails: (state, action) => {
        state.user_details= action.payload 
      },
      removeUserDetails: (state, action) => {
        state.user_details= ""
      }
    }
  });
  
  export const { storeUserDetails, removeUserDetails } = UserDetailStateSlice.actions;
  
  export default UserDetailStateSlice.reducer;